import { DATE_FORMAT } from "helpers/common";
import React from "react";


const Columns = ({ }) => [
    {
        dataField: "coinName",
        text: "Coin Name",
        formatter: (_, row) => <span className="text-capitalize">{row?.coinName}</span>,
    },
    {
        dataField: "coinSymbol",
        text: "Coin Symbol",
        formatter: (_, row) => <span className="text-capitalize">{row?.coinSymbol}</span>,
    },
    {
        dataField: "amount",
        text: "Amount",
        formatter: (_, row) => <span className="text">{row?.amount}</span>,
      },
      {
        dataField: "rank",
        text: "Rank",
        formatter: (_, row) => <span className="text">{row?.rank}</span>,
      },
      {
        dataField: "weekDayNo",
        text: "Week Day No",
        formatter: (_, row) => <span className="text">{row?.weekDayNo}</span>,
      },
      {
        dataField: "weekNo",
        text: "Week No",
        formatter: (_, row) => <span className="text">{row?.weekNo}</span>,
      },
      {
        dataField: "year",
        text: "Year",
        formatter: (_, row) => <span className="text">{row?.year}</span>,
      },
      {
        dataField: "date_created_utc",
        text: "Created At",
        formatter: (_, row) => <span className="text-capitalize">{row.date_created_utc && DATE_FORMAT(row.date_created_utc)}</span>,
      },
];
export default Columns;
